// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".silentbox-single{cursor:pointer;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
